<div class="content-container">
    <mat-card class="login-component">
        <mat-card-header class="login-header">
            <mat-card-title class="mat-card-title">
                <mat-icon class="material-symbols-outlined">
                    person
                </mat-icon>
                <span>
                    User: {{ itemEnvelope?.ItemId}}
                </span>
            </mat-card-title>
            <mat-card-subtitle class="mat-card-subtitle">
                {{ subtitle }}
            </mat-card-subtitle>
        </mat-card-header>
        <mat-card-content>
            <form>
                <mat-form-field appearance="outline">
                    <mat-label>User UID</mat-label>
                    <input *ngIf="itemEnvelope" matInput name="Name" placeholder="Unique ID" [(ngModel)]="itemEnvelope.Document.Item.UID" />
                </mat-form-field>
            </form>
            <mat-tab-group (selectedTabChange)="onTabChange($event)">
                <br />
                <mat-tab label="General">
                    <br />
                    <form>
                        <mat-form-field appearance="outline">
                            <mat-label>Password</mat-label>
                            <input matInput name="Password" placeholder="(Password)" />
                        </mat-form-field>
                    </form>
                    <mat-slide-toggle *ngIf="itemEnvelope" [(ngModel)]="itemEnvelope.Document.Item.IsDisabled">Disabled</mat-slide-toggle>
                    <br />
                    <mat-slide-toggle *ngIf="itemEnvelope" [(ngModel)]="itemEnvelope.Document.Item.IsLocked">Locked</mat-slide-toggle>
                    <br />
                    <mat-slide-toggle *ngIf="itemEnvelope" [(ngModel)]="itemEnvelope.Document.Item.IsRequireChangePassword">Password Change Required</mat-slide-toggle>
                    <br />
                </mat-tab>
                <mat-tab label="Roles">
                    <br />
                    <form>
                        <mat-form-field appearance="outline">
                            <mat-label>Available Roles</mat-label>
                            <mat-select *ngIf="itemEnvelope" name="AvailableRoles" [(ngModel)]="selectedRole">
                                <mat-option *ngFor="let role of availableRoles" [value]="role">{{ role.UID }}</mat-option>
                            </mat-select>
                        </mat-form-field>
                        <button mat-button (click)="addSelectedRoleToUser()" [disabled]="this.selectedRole == null">
                            <mat-icon class="material-symbols-outlined">
                                add
                            </mat-icon>
                            ADD ROLE
                        </button>
                        <br />
                        <table mat-table *ngIf="itemEnvelope" [dataSource]="userRolesDatasource" class="mat-elevation-z8" matSort>
                            <ng-container matColumnDef="Avatar">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
                                <td mat-cell *matCellDef="let userRole">
                                    <mat-icon class="material-symbols-outlined">
                                        work
                                    </mat-icon>
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="Role">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header> Name </th>
                                <td mat-cell *matCellDef="let userRole" (click)="appService.navigateTo('role/' + userRole.RoleId, '')">{{ getRoleUIDFromRoleId(userRole.RoleId) }}</td>
                            </ng-container>
                            <ng-container matColumnDef="Delete">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
                                <td mat-cell *matCellDef="let userRole">
                                    <mat-icon class="material-symbols-outlined" (click)="deleteUserRole(userRole)">
                                        delete
                                    </mat-icon>
                                </td>
                            </ng-container>
                            <tr mat-header-row *matHeaderRowDef="displayedUserRolesColumns"></tr>
                            <tr mat-row *matRowDef="let row; columns: displayedUserRolesColumns;"></tr>
                        </table>
                    </form>
                </mat-tab>
                <mat-tab label="Claims">
                    <br />
                    <form>
                        <span>
                            <mat-form-field appearance="outline">
                                <mat-label>Claim Type</mat-label>
                                <mat-select *ngIf="itemEnvelope" name="ClaimTypes" [(ngModel)]="selectedClaimType">
                                    <mat-option *ngFor="let claimType of availableClaimTypes" [value]="claimType">{{ claimType.UID }}</mat-option>
                                </mat-select>
                            </mat-form-field>
                            &nbsp;
                            &nbsp;
                            <mat-form-field appearance="outline">
                                <mat-label>Value</mat-label>
                                <input matInput name="ClaimValue" placeholder="Claim Value" [(ngModel)]="enteredClaimValue" />
                            </mat-form-field>
                        </span>
                        &nbsp;
                        &nbsp;
                        <button mat-button (click)="addClaimToUser(selectedClaimType, enteredClaimValue)" [disabled]="this.enteredClaimValue == '' || this.selectedClaimType == null">
                            <mat-icon class="material-symbols-outlined">
                                add
                            </mat-icon>
                            ADD CLAIM
                        </button>
                        <br />
                        <table mat-table *ngIf="itemEnvelope" [dataSource]="userClaimsDatasource" class="mat-elevation-z8" matSort>
                            <ng-container matColumnDef="Avatar">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
                                <td mat-cell *matCellDef="let userClaim">
                                    <mat-icon class="material-symbols-outlined">
                                        personal_places
                                    </mat-icon>
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="ClaimType">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>Claim Type</th>
                                <td mat-cell *matCellDef="let userClaim">{{ getClaimTypeUIDFromClaimTypeId(userClaim.ClaimTypeId) }}</td>
                            </ng-container>
                            <ng-container matColumnDef="ClaimValue">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>Claim Value</th>
                                <td mat-cell *matCellDef="let userClaim">{{ userClaim.ClaimValue }}</td>
                            </ng-container>
                            <ng-container matColumnDef="Delete">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
                                <td mat-cell *matCellDef="let userClaim">
                                    <mat-icon class="material-symbols-outlined" (click)="deleteUserClaim(userClaim)">
                                        delete
                                    </mat-icon>
                                </td>
                            </ng-container>
                            <tr mat-header-row *matHeaderRowDef="displayedUserClaimsColumns"></tr>
                            <tr mat-row *matRowDef="let row; columns: displayedUserClaimsColumns;"></tr>
                        </table>
                    </form>
                </mat-tab>
                <mat-tab *ngIf="!isRevisionMode" label="History">
                    <div class="history-container">
                        <div class="history-container-section">
                            <app-history #appHistory *ngIf="this.itemEnvelope" [itemEnvelope]="this.itemEnvelope" [itemService]="this.itemService"></app-history>
                        </div>
                    </div>
                </mat-tab>
            </mat-tab-group>
        </mat-card-content>
        <mat-card-footer>
        </mat-card-footer>
    </mat-card>
</div>

